import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function aggregatorsFilter({
  jwt,
  navRoutesConfig,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  let filtering = filterHelper(navRoutesConfig);

  if (!jwt.isAggregator) {
    filtering = filtering.removeRouteSubById(
      "InvestingTools",
      "InvestingToolsAggregators",
    );
  }

  return filtering.getFilteredRoutesConfig();
}
